module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-mobile",
    attrs: {
      "id": "menu"
    }
  }, [_c('a', {
    staticClass: "logotype",
    attrs: {
      "href": "http://hihonor.com",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hamburger",
    on: {
      "click": function($event) {
        _vm.openMenu()
      }
    }
  }, [_c('div', {
    class: {
      open: _vm.menuOpen
    },
    attrs: {
      "id": "nav-icon3"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "fold",
    class: {
      open: _vm.menuOpen
    }
  }, [_c('a', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.goTo('products')
      }
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('a', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.goTo('community')
      }
    }
  }, [_vm._v("Community")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27a24c48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuMobile.vue
// module id = 226
// module chunks = 1